function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M0 3.111L3 0l3 3.111H3.75v3.111h-1.5v-3.11H0zm2.25 5.445c0 .427.337.777.75.777s.75-.35.75-.777c0-.428-.337-.778-.75-.778s-.75.35-.75.778zm0 3.11c0 .428.337.778.75.778s.75-.35.75-.777c0-.428-.337-.778-.75-.778s-.75.35-.75.778zm7.5-.777V7.778h-1.5v3.11H6L9 14l3-3.111H9.75zm0-5.445c0-.427-.338-.777-.75-.777s-.75.35-.75.777c0 .428.338.778.75.778s.75-.35.75-.778zm0-3.11c0-.428-.338-.778-.75-.778s-.75.35-.75.777c0 .428.338.778.75.778s.75-.35.75-.778z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H12V14H0z"
})));

var SvgIconRearrange = function SvgIconRearrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRearrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-rearrange.5d301c43.svg";
export { ForwardRef as ReactComponent };